import React, {useContext, useState} from 'react';

import {ApiRoutes, FetchContext, HttpMethods, ToastContext} from '../../contexts';

import {useAggregatedState} from '../../../helpers';

export const RegioniContext = React.createContext(null);

const {Provider} = RegioniContext;

export const RegioniProvider = (props) => {
    const {
        showWarningMessage,
        showSuccessMessage,
        showErrorMessage,
        showLoadingMessage,
        closeLoadingMessage,
    } = useContext(ToastContext);
    const {fetchOk, fetchAuthorized} = useContext(FetchContext);
    const [state, setState] = useAggregatedState({
        regioni: {result: [], totalCount: 0,},
    });

    const {regioni} = state;

    const [isLoadingRegioni, setIsLoadingRegioni] = useState(false);
    const getRegioniAsync = async (pageIndex = 0, pageSize = 100, term = null, valid = false) => {
        try {
            setIsLoadingRegioni(true);
            valid = valid ? true : null;
            const r = await fetchAuthorized(ApiRoutes.Regione.GetRegioni({pageIndex, pageSize, term, valid}), {
                method: HttpMethods.GET
            });
            const list = await r.json();
            list.result.forEach(x => {
                x.inizioValidita = new Date(x.inizioValidita);
                x.fineValidita = x.fineValidita ? new Date(x.fineValidita) : null;
            })
            setState({regioni: list});
        } catch (e) {
            console.debug(e);
        } finally {
            setIsLoadingRegioni(false);
        }
    }

    const [isDeletingRegione, setIsDeletingRegione] = useState(false);
    const deleteRegioneAsync = async (regioneId,) => {
        try {
            setIsDeletingRegione(true);
            if (window.confirm("Confermare l'eliminazione?")) {
                const r = await fetchAuthorized(ApiRoutes.Regione.DeleteRegione({regioneId}), {
                    method: HttpMethods.DELETE
                });
                const list = regioni.result;
                list.forEach(x => {
                    if (x.id == regioneId)
                        x.fineValidita = new Date();
                });
                setState({
                    regioni: {
                        ...regioni, result: list
                    }
                });
                showSuccessMessage(`Regione con id ${regioneId} eliminato`);
            }
        } catch (e) {
            console.debug(e);
        } finally {
            setIsDeletingRegione(false);
        }
    }

    return (
        <Provider value={{
            state,
            setState,

            isLoadingRegioni,
            getRegioniAsync,

            isDeletingRegione,
            deleteRegioneAsync,
        }}>
            {props.children}
        </Provider>
    );
}